// import React from 'react';
import { Navigate } from "react-router-dom";
import { useAuth } from "../../api/auth/AuthProvider";
import { LOGIN_ROUTE } from "../../routing/app-routes";
import RegistrationComplete from "../pages/email-verification/RegistrationComplete";

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  if (auth.token) {
    if (auth.user?.emailVerified) {
      return children;
    } else {
      return <RegistrationComplete />;
    }
  }
  return <Navigate to={LOGIN_ROUTE} />;
};

export default ProtectedRoute;
